// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q2l7","input":"styles_input__2saNZ"};